import { render } from "./Services.vue?vue&type=template&id=62d24068&scoped=true"
const script = {}

import "./Services.vue?vue&type=style&index=0&id=62d24068&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d24068"]])

export default __exports__